import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Image from '@plone/volto/components/theme/Image/Image';

import InFerraraLogo from './in_ferrara_logo.png';

const DoveDormireTabContent = ({ color }) => {
  const intl = useIntl();
  return (
    <div>
      <div className="top-info">
        <div>
          {intl.formatMessage(messages.prenotazioni_dove_dormire_descr)}
        </div>
        <div className="logo">
          <Image src={InFerraraLogo} width="150" alt="" loading="lazy" />
        </div>
      </div>
      <div className="buttons-container">
        <UniversalLink
          href={`https://booking.inferrara.it/${intl.locale === 'en' ? intl.locale : ''}`}
          className={cx(`${color} ui button`)}
        >
          Ferrara
        </UniversalLink>
      </div>
    </div>
  );
};

export default DoveDormireTabContent;

const messages = defineMessages({
  prenotazioni_dove_dormire_descr: {
    id: 'prenotazioni_dove_dormire_descr',
    defaultMessage:
      'Clicca sulla tua destinazione, scopri le strutture disponibili e prenota comodamente online.',
  },
});
